import styled from 'styled-components';
import { colors } from '~/styles/colors';

export const GraphContainer = styled.div`
  @media only screen and (max-width: 600px) {
    padding-left: 0px
  }
  width: 100%;
`;

export const TitleFieldNobreak = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 33px;
  div {
    display: flex;
    gap: 10px;
  }
`;

export const TitleColumn = styled.div`
  display: flex;
  flex-direction: column;
  h3 {
    font-size: 14px;
  }
  h4 {
    color: ${colors.text['sub-500']};
    font-size: 14px;
    font-weight: 400;
    margin-left: 22px;
  }
`;

export const LoaderModal = styled.div`
  width: 100%;
  z-index: 2;
  background-color: #020202d0;
  position: absolute;
  top: 0;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding-top: 10px;
  p {
    color: ${colors.White};
    font-size: 11px;
  }
`;

export const StatusRealTime = styled.div`
  background-color: ${colors.brand.primary.lighter};
  color: ${colors.text['soft-400']};
  font-size: 11px;
  font-weight: 600;
  text-align: center;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
`;

export const HeaderDevice = styled.div`
  text-align: center;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px;
  margin-bottom: 20px;
  @media (max-width: 522px) {
    flex-direction: column;
    align-items: start;
    gap: 10px;
  }
`;

export const HeaderDeviceInfo = styled.div`
  display: flex;
  align-items: start;
  flex-direction: column;
  justify-content: start;
  h3 {
    font-size: 18px;
    font-weight: 600;
    margin: 0;
  }
  span {
    font-size: 14px;
    font-weight: 400;
    color: ${colors.text['sub-500']};
  }
`;

export const ErrorPageContainer = styled.div`
  border: 1px solid ${colors.Grey050};
  border-radius: 5px;
  padding: 20px 35%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  color: ${colors.text['sub-500']};
  strong {
    color: ${colors.text['main-900']};
  }
  @media (max-width: 790px) {
    padding: 20px;
  }
`;

export const ButtonWithoutStyle = styled.button`
  all: unset;
  display: block; 
  cursor: pointer; 
`;
